function VpLoaderProps(props, fallbackId) {
  const { id = fallbackId, size, variantStyle, ...restProps } = props;
  delete restProps.ref;
  return {
    logicProps: {
      id,
      size,
      variantStyle
    },
    spreadableProps: restProps
  };
}

export { VpLoaderProps };
